import { Navigate, Route, Routes } from 'react-router-dom'

// Import pages
import Facturas from './pages/Facturas/cliente_factura'
import ClinicaFactura from './pages/Facturas/clinica_factura'
import TodasFacturas from './pages/Facturas/todas_facturas'
import Home from './pages/Home'

/**
 * Configuración de rutas de la aplicación
 */
const AppRoutes = () => {
  return (
    <Routes>
      <Route path='/' element={<Home />} />
      <Route path='/facturas' element={<Facturas />} />
      <Route path='/facturas/clinica' element={<ClinicaFactura />} />
      <Route path='/facturas/administracion' element={<TodasFacturas />} />
      <Route path='*' element={<Navigate to='/' replace />} />
    </Routes>
  )
}

export default AppRoutes
